export default function PhoneValidator(message: string) {
  return ({}) => ({
    validator: (_, value) => {
      if (!value) {
        return Promise.resolve(); // Skip validation if the field is empty
      }

      const expr = new RegExp(
        /^\+(1|2[0-9]|3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9]{1,2})\d{5,16}$/,
        'i'
      );

      if (typeof value.trim === 'function') {
        // trim value if it is a string
        value = value.trim();
      }

      if (expr.test(value)) {
        return Promise.resolve();
      } else {
        return Promise.reject(new Error(message));
      }
    }
  });
}
